'use strict';

(function () {
    'use strict';

    i18nConfig.$inject = ['$translateProvider'];
    localStorageConfig.$inject = ['localStorageServiceProvider'];
    angular.module('app.core').config(i18nConfig).config(localStorageConfig);

    /* @ngInject */
    function localStorageConfig(localStorageServiceProvider) {
        localStorageServiceProvider.setPrefix('app').setStorageType('sessionStorage').setNotify(true, false);
    }

    /* @ngInject */
    function i18nConfig($translateProvider) {
        var lang = angular.element(document).find('html').attr('lang');

        var locale = {
            'en-US': {
                decimal: ',',
                thousands: '.',
                grouping: [3],
                currency: ['', '\xA0\u20AC'],
                dateTime: '%A, %e %B %Y %X',
                date: '%d/%m/%Y',
                time: '%H: %M: %S',
                periods: ['AM', 'PM'],
                days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            },
            el: {
                decimal: ',',
                thousands: '.',
                grouping: [3],
                currency: ['', '\xA0\u20AC'],
                dateTime: '%A, %e %B %Y %X',
                date: '%d/%m/%Y',
                time: '%H:%M:%S',
                periods: ['πμ', 'μμ'],
                days: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
                shortDays: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
                months: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
                shortMonths: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαϊ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ']
            }
        };

        $translateProvider.preferredLanguage(lang);
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

        moment.updateLocale('en', {
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4 // The week that contains Jan 4th is the first week of the year.
            }
        });

        moment.updateLocale('el', {
            relativeTime: {
                past: 'πριν %s'
            }
        });

        moment.locale(lang);

        if (locale[lang]) {
            d3.currentLocale = d3.locale(locale[lang]);
        }
    }
})();